import router from '@/router'

export function checkLogin (res) {
  if (res.data.code >= 2000 && res.data.code < 3000) {
    return router.push({ path: '/login' })
  }
}

export function isNotLogin(res) {
  if (res.data.code >= 2000 && res.data.code < 3000) {
    return true
  }
}
